import {otsBaseApi} from "../../ots-api";
import {NotificationReceiverProfile} from "../../../model/notification-receiver-profile";

const ALL_TAG_TYPES = [
  "NotificationReceiverProfiles",
  "ObjectObjectChangeLogs",
] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

const notificationReceiverProfileApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotificationReceiverProfiles: builder.query<
      NotificationReceiverProfile[],
      void
    >({
      query: () => ({
        url: `/notification-receiver-profiles/all`,
        method: 'GET',
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "NotificationReceiverProfiles", id} as const)),
            {type: "NotificationReceiverProfiles", id: "LIST"}
          ];
        } else {
          return [{type: "NotificationReceiverProfiles", id: "LIST"}];
        }
      },
    }),
    getNotificationReceiverProfile: builder.query<NotificationReceiverProfile, string>({
      query: (id) => ({
        url: `/notification-receiver-profiles/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "NotificationReceiverProfiles", id}]
    }),
    createNotificationReceiverProfile: builder.mutation<NotificationReceiverProfile, Partial<NotificationReceiverProfile>>({
      query: (mapping) => ({
        url: "/notification-receiver-profiles",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "NotificationReceiverProfiles", id: "LIST"}]
    }),
    updateNotificationReceiverProfile: builder.mutation<NotificationReceiverProfile, Partial<NotificationReceiverProfile>>({
      query: (mapping) => ({
        url: "/notification-receiver-profiles",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "NotificationReceiverProfiles", id},
        {type: "ObjectObjectChangeLogs", id}
      ]
    }),
    deleteNotificationReceiverProfile: builder.mutation<void, Partial<NotificationReceiverProfile>>({
      query: (mapping) => ({
        url: "/notification-receiver-profiles",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "NotificationReceiverProfiles", id}]
    }),
  })
});

export const {
  useGetAllNotificationReceiverProfilesQuery,
  useGetNotificationReceiverProfileQuery,
  useCreateNotificationReceiverProfileMutation,
  useUpdateNotificationReceiverProfileMutation,
  useDeleteNotificationReceiverProfileMutation,
} = notificationReceiverProfileApi;
